import React, { useState } from 'react';
import { Box, Grid, Typography, Snackbar, Alert, AlertColor } from '@mui/material';
import MppContextProvider from './context/MppContextProvider';
import MppUploader from './components/MppUploader';
import MppTable from './components/MppTable';

const IMS: React.FC = () => {
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState('');
  const [snackbarSeverity, setSnackbarSeverity] = useState<AlertColor>('success');

  const showNotification = (message: string, severity: AlertColor = 'success') => {
    setSnackbarMessage(message);
    setSnackbarSeverity(severity);
    setSnackbarOpen(true);
  };

  const handleUploadSuccess = () => {
    showNotification('File uploaded successfully!');
  };

  const handleDeleteSuccess = () => {
    showNotification('Schedule deleted successfully!');
  };

  const handleUpdateSuccess = () => {
    showNotification('Schedule updated successfully!');
  };

  const handleOverwriteSuccess = () => {
    showNotification('Schedule replaced successfully!');
  };

  const handleUpdateError = () => {
    showNotification('Failed to update schedule. Please try again.', 'error');
  };

  const handleSnackbarClose = () => {
    setSnackbarOpen(false);
  };

  return (
    <MppContextProvider>
      <Box sx={{ width: '100%', p: 2 }}>
        <Grid container spacing={2}>
          <Grid size={{ xs: 12 }}>
            <Grid
              display="flex"
              justifyContent="space-between"
              alignItems="center"
              sx={{ mb: 2 }}
            >
              <Typography variant="h6">
                Manage Schedules
              </Typography>
              <Grid display="flex" alignItems="center">
                <MppUploader onUploadSuccess={handleUploadSuccess} />
              </Grid>
            </Grid>
          </Grid>
          <Grid size={{ xs: 12 }}>
            {/* <Typography variant="h6" sx={{ mb: 1 }}>
              Master Schedule Files List
            </Typography> */}
            <MppTable
              onDeleteSuccess={handleDeleteSuccess}
              onUpdateSuccess={handleUpdateSuccess}
              onUpdateError={handleUpdateError}
              onOverwriteSuccess={handleOverwriteSuccess}
            />
          </Grid>
        </Grid>
      </Box>
      <Snackbar
        open={snackbarOpen}
        autoHideDuration={4000}
        onClose={handleSnackbarClose}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      >
        <Alert onClose={handleSnackbarClose} severity={snackbarSeverity} sx={{ width: '100%' }}>
          {snackbarMessage}
        </Alert>
      </Snackbar>
    </MppContextProvider>
  );
};

export default IMS;
